﻿// String.js - liberated from MicrosoftAjax.js on 03/28/10 by Sky Sanders 
// permalink: http://stackoverflow.com/a/2534834/2343

/*
    Copyright (c) 2009, CodePlex Foundation
    All rights reserved.

    Redistribution and use in source and binary forms, with or without modification, are permitted 
    provided that the following conditions are met:

    *   Redistributions of source code must retain the above copyright notice, this list of conditions 
        and the following disclaimer.

    *   Redistributions in binary form must reproduce the above copyright notice, this list of conditions 
        and the following disclaimer in the documentation and/or other materials provided with the distribution.

    *   Neither the name of CodePlex Foundation nor the names of its contributors may be used to endorse or 
        promote products derived from this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY EXPRESS OR IMPLIED 
    WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR 
    A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE 
    FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT 
    LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS 
    INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, 
    OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN 
    IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.</textarea>
*/

(function (window) {

    $String_type = String;
    $String_type.__typeName = 'String';
    $String_type.__class = true;
    $String_type.__numbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

    $String_prototype = $String_type.prototype;
    $String_prototype.endsWith = function string$endsWith(suffix) {
        /// <summary>Determines whether the end of this instance matches the specified string.</summary>
        /// <param name="suffix" type="String">A string to compare to.</param>
        /// <returns type="Boolean">true if suffix matches the end of this instance; otherwise, false.</returns>
        return (this.substr(this.length - suffix.length) === suffix);
    };

    $String_prototype.startsWith = function string$startsWith(prefix) {
        /// <summary >Determines whether the beginning of this instance matches the specified string.</summary>
        /// <param name="prefix" type="String">The String to compare.</param>
        /// <returns type="Boolean">true if prefix matches the beginning of this string; otherwise, false.</returns>
        return (this.substr(0, prefix.length) === prefix);
    };

    $String_prototype.trim = function string$trim() {
        /// <summary >Removes all leading and trailing white-space characters from the current String object.</summary>
        /// <returns type="String">The string that remains after all white-space characters are removed from the start and end of the current String object.</returns>
        return this.replace(/^\s+|\s+$/g, '');
    };

    $String_prototype.trimEnd = function string$trimEnd() {
        /// <summary >Removes all trailing white spaces from the current String object.</summary>
        /// <returns type="String">The string that remains after all white-space characters are removed from the end of the current String object.</returns>
        return this.replace(/\s+$/, '');
    };

    $String_prototype.trimStart = function string$trimStart() {
        /// <summary >Removes all leading white spaces from the current String object.</summary>
        /// <returns type="String">The string that remains after all white-space characters are removed from the start of the current String object.</returns>
        return this.replace(/^\s+/, '');
    };

    $String_prototype.repeat = String.prototype.repeat || function (n) { return new Array(n + 1).join(this.toString()) };

    $String_prototype.numberString = function (allowNegative) {
        if (allowNegative === void 0) { allowNegative = false; }
        var result = "";
        var prefix = "";
        var wasNumber = false;
        var i;
        var chr;
        for (i = 0; i <= this.length - 1; i++) {
            chr = this.charAt(i);
            if ($String_type.__numbers.indexOf(chr) > -1) {
                result = result + chr;
                wasNumber = true;
            }
            else {
                if (!wasNumber && allowNegative && prefix === "" && (chr === "-" || chr === "−")) {
                    prefix = "-";
                }
                wasNumber = false;
            }
        }
        return prefix + result;
    };

    $String_prototype.toInteger = function (allowNegative, minValue) {
        if (allowNegative === void 0) { allowNegative = false; }
        if (minValue === void 0) { minValue = 0; }
        var temp = this.numberString(allowNegative);
        if (minValue === null || minValue === undefined) {
            minValue = 0;
        }
        if (temp === "" || temp === "-" || temp === "−") {
            temp = minValue;
        }
        return Math.max(parseInt(temp, 10), minValue);
    };

    $String_prototype.toDecimal = function (allowNegative, removeSpaces) {
        if (allowNegative === void 0) { allowNegative = false; }
        if (removeSpaces === void 0) { removeSpaces = true; }
        var temp = this.trim();
        if (removeSpaces) {
            temp = temp.replace(/\s/g, "");
        }
        var multiplier = 1;
        var integer = 0;
        var decimal = 0;
        if (temp.length > 0) {
            var integerStr = "";
            var decimalStr = "";
            var index = 0;
            var wasNumber = false;
            var i;
            for (i = 0; i <= temp.length - 1; i++) {
                var chr = temp.charAt(i);
                if (removeSpaces && chr === " ") {
                    continue;
                }
                if ($String_type.__numbers.indexOf(chr) > -1) {
                    switch (index) {
                        case 0:
                            integerStr = integerStr + chr;
                            break;
                        case 1:
                            decimalStr = decimalStr + chr;
                            break;
                    }
                    wasNumber = true;
                }
                else {
                    if (wasNumber) {
                        index = index + 1;
                    }
                    else if (index === 0) {
                        if (chr === "-" || chr === "−") {
                            if (allowNegative && multiplier === 1) {
                                multiplier = -1;
                            }
                        } else if (integerStr === "") { //decimal separator in the start of the string
                            integerStr = "0";
                            index = index + 1;
                        }
                    }
                    wasNumber = false;
                }
            }
            if (integerStr.length > 0) {
                if (integerStr.length > 9) {
                    integerStr = integerStr.substr(0, 9);
                }
                integer = parseInt(integerStr, 10);
                if (decimalStr.length > 0) {
                    if (decimalStr.length > 6) {
                        decimalStr = decimalStr.substr(0, 6);
                    }
                    else if (decimalStr.length < 6) {
                        var j = decimalStr.length;
                        var k;
                        for (k = 1; k <= 6 - j; k++) {
                            decimalStr = decimalStr + "0";
                        }
                    }
                    decimal = parseInt(decimalStr, 10);
                }
            }
        }
        return multiplier * (integer + decimal / 1000000);
    };

    $String_prototype.parseDateParts = function (defaultDate) {
        var d = defaultDate;
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var temp = this.trim();
        if (temp.length > 0) {
            var yearStr = "";
            var monthStr = "";
            var dayStr = "";
            var index = 0;
            var wasNumber = false;
            var wasIncreased = false;
            var i;
            for (i = 0; i <= temp.length - 1; i++) {
                var chr = temp.charAt(i);
                if ($String_type.__numbers.indexOf(chr) > -1) {
                    wasIncreased = false;
                    switch (index) {
                        case 0:
                            dayStr = dayStr + chr;
                            if (dayStr.length > 1) {
                                index = index + 1;
                                wasIncreased = true;
                            }
                            break;
                        case 1:
                            monthStr = monthStr + chr;
                            if (monthStr.length > 1) {
                                index = index + 1;
                                wasIncreased = true;
                            }
                            break;
                        case 2:
                            yearStr = yearStr + chr;
                            if (yearStr.length > 3) {
                                index = index + 1;
                                wasIncreased = true;
                            }
                            break;
                    }
                    wasNumber = true;
                }
                else {
                    if (wasNumber && !wasIncreased) {
                        index = index + 1;
                    }
                    wasNumber = false;
                }
            }
            if (dayStr.length > 0) {
                day = Math.min(31, Math.max(1, parseInt(dayStr, 10)));
                if (monthStr.length > 0) {
                    month = Math.min(12, Math.max(1, parseInt(monthStr, 10)));
                    if (yearStr.length > 0) {
                        year = Math.min(2100, Math.max(10, parseInt(yearStr, 10)));
                        if (year < 100) {
                            year = 2000 + year;
                        }
                    }
                }
                if ((month === 4 || month === 6 || month === 9 || month === 11) && (day > 30)) {
                    day = 30;
                }
                else if (month === 2) {
                    if (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) {
                        day = Math.min(29, day);
                    }
                    else {
                        day = Math.min(28, day);
                    }
                }
            }
        }
        return {
            year: year, 
            month: month - 1, 
            day: day
        };
    };

    $String_prototype.toDate = function (defaultDate) {
        if (defaultDate === void 0) { defaultDate = new Date(); }
        var parts = this.parseDateParts(defaultDate);
        return new Date(parts.year, parts.month, parts.day, 0, 0, 0, 0);
    };

    $String_prototype.toUtcDate = function (defaultDate) {
        if (defaultDate === void 0) {
            var newDate = new Date();
            defaultDate = new Date(Date.UTC(newDate.getUTCFullYear(), newDate.getUTCMonth(), newDate.getUTCDate(), 0, 0, 0, 0));
        }
        var parts = this.parseDateParts(defaultDate);
        return new Date(Date.UTC(parts.year, parts.month, parts.day, 0, 0, 0, 0));
    };

    $String_prototype.parseTimeParts = function (defaultDate, maxHour) {
        if (maxHour === null || maxHour === undefined) {
            maxHour = 23;
        }
        var hourMaxLength = maxHour.toString(10).length;
        var d = defaultDate;
        var hour = d !== null && d !== undefined ? d.getHours() : 0;
        var minute = d !== null && d !== undefined ? d.getMinutes() : 0;
        var temp = this.trim();
        if (temp.length > 0) {
            minute = 0;
            var hourStr = "";
            var minuteStr = "";
            var index = 0;
            var wasNumber = false;
            var wasIncreased = false;
            var i;
            for (i = 0; i <= temp.length - 1; i++) {
                var chr = temp.charAt(i);
                if ($String_type.__numbers.indexOf(chr) > -1) {
                    wasIncreased = false;
                    switch (index) {
                    case 0:
                        hourStr = hourStr + chr;
                        if (hourStr.length > hourMaxLength - 1) {
                            index = index + 1;
                            wasIncreased = true;
                        }
                        break;
                    case 1:
                        minuteStr = minuteStr + chr;
                        if (minuteStr.length > 1) {
                            index = index + 1;
                            wasIncreased = true;
                        }
                        break;
                    }
                    wasNumber = true;
                } else {
                    if (wasNumber && !wasIncreased) {
                        index = index + 1;
                    }
                    wasNumber = false;
                }
            }
            if (hourStr.length > 0) {
                hour = Math.min(maxHour, parseInt(hourStr, 10));
                if (minuteStr.length > 1) {
                    minute = Math.min(59, parseInt(minuteStr, 10));
                } else if (minuteStr.length > 0) {
                    minute = Math.min(59, 10 * parseInt(minuteStr, 10));
                }
            }
        }
        return {
            hour: hour, 
            minute: minute
        };
    };

    $String_prototype.toTime = function () {
        var parts = this.parseTimeParts(new Date());
        return new Date(0, 0, 0, parts.hour, parts.minute, 0, 0);
    };

    $String_prototype.toUtcTime = function () {
        var newDate = new Date();
        var parts = this.parseTimeParts(new Date(Date.UTC(0, 0, 0, newDate.getUTCHours(), newDate.getUTCMinutes(), 0, 0)));
        return new Date(Date.UTC(0, 0, 0, parts.hour, parts.minute, 0, 0));
    };

    $String_prototype.toTimeSpan = function () {
        var parts = this.parseTimeParts(null, 1000000);
        return parts.hour + (parts.minute / 60);
    };

    $String_prototype.equalIgnoreCase = function(str)
    {
        return (str !== null
            && str !== undefined
            && typeof str === "string"
            && this.toUpperCase() === str.toUpperCase());
    };

    $String_type.format = function string$format(format, args) {
        /// <summary>Replaces the format items in a specified String with the text equivalents of the values of   corresponding object instances. The invariant culture will be used to format dates and numbers.</summary>
        /// <param name="format" type="String">A format string.</param>
        /// <param name="args" parameterArray="true" mayBeNull="true">The objects to format.</param>
        /// <returns type="String">A copy of format in which the format items have been replaced by the   string equivalent of the corresponding instances of object arguments.</returns>
        return String._toFormattedString(false, arguments);
    };

    $String_type._toFormattedString = function string$_toFormattedString(useLocale, args) {
        var result = '';
        var format = args[0];

        for (var i = 0; ;) {
            // Find the next opening or closing brace
            var open = format.indexOf('{', i);
            var close = format.indexOf('}', i);
            if ((open < 0) && (close < 0)) {
                // Not found: copy the end of the string and break
                result += format.slice(i);
                break;
            }
            if ((close > 0) && ((close < open) || (open < 0))) {

                if (format.charAt(close + 1) !== '}') {
                    throw new Error('format stringFormatBraceMismatch');
                }

                result += format.slice(i, close + 1);
                i = close + 2;
                continue;
            }

            // Copy the string before the brace
            result += format.slice(i, open);
            i = open + 1;

            // Check for double braces (which display as one and are not arguments)
            if (format.charAt(i) === '{') {
                result += '{';
                i++;
                continue;
            }

            if (close < 0) throw new Error('format stringFormatBraceMismatch');


            // Find the closing brace

            // Get the string between the braces, and split it around the ':' (if any)
            var brace = format.substring(i, close);
            var colonIndex = brace.indexOf(':');
            var argNumber = parseInt((colonIndex < 0) ? brace : brace.substring(0, colonIndex), 10) + 1;

            if (isNaN(argNumber)) throw new Error('format stringFormatInvalid');

            var argFormat = (colonIndex < 0) ? '' : brace.substring(colonIndex + 1);

            var arg = args[argNumber];
            if (typeof (arg) === "undefined" || arg === null) {
                arg = '';
            }

            // If it has a toFormattedString method, call it.  Otherwise, call toString()
            if (arg.toFormattedString) {
                result += arg.toFormattedString(argFormat);
            }
            else if (useLocale && arg.localeFormat) {
                result += arg.localeFormat(argFormat);
            }
            else if (arg.format) {
                result += arg.format(argFormat);
            }
            else
                result += arg.toString();

            i = close + 1;
        }

        return result;
    };

    //ECMAScript 2015 Polyfill
    if (!$String_prototype.includes) {
        $String_prototype.includes = function(search, start) {
            "use strict";
            if (typeof start !== "number") {
                start = 0;
            }
            if (start + search.length > this.length) {
                return false;
            } else {
                return this.indexOf(search, start) !== -1;
            }
        };
    }

})(typeof window !== "undefined" ? window : this);